import { render, staticRenderFns } from "./PolygonEditMenu.vue?vue&type=template&id=7ab39be8&scoped=true"
import script from "./PolygonEditMenu.vue?vue&type=script&lang=js"
export * from "./PolygonEditMenu.vue?vue&type=script&lang=js"
import style0 from "./PolygonEditMenu.vue?vue&type=style&index=0&id=7ab39be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab39be8",
  null
  
)

export default component.exports